module.exports = __webpack_public_path__ + "static/img/logo.3dff091.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 346
// module chunks = 1